export const INIT_SESSION = 'InitSessionAction';
export const SessionDefaultSettings = { id: 'undefined' };

export const sessionReducer = (state = SessionDefaultSettings , action) => {
    switch (action.type) {
        case INIT_SESSION:
            return { id: action.payload };
        default:
            break;
    }
    return state;
};

